import type { PartRequestPlaceholder } from './Details'

import Checkbox from '@/gf/components/Checkbox'
import { Table, Tbody, Td, Th, Thead, Tr } from '@/gf/components/Table'

const PartRequestsTable = ({
  addToQuoteVisible,
  partRequests,
  setPartRequests,
}: {
  addToQuoteVisible: boolean
  partRequests: PartRequestPlaceholder[]
  setPartRequests: (pr) => void
}) => {
  const alterPartRequest = ({ id, addToQuote }) => {
    const placeholders = partRequests.reduce(
      (acc: PartRequestPlaceholder[], pr: PartRequestPlaceholder) => {
        if (pr.id === id) {
          const newPlaceholder = {
            ...pr,
            addToQuote,
          }
          return [...acc, newPlaceholder]
        }

        return [...acc, pr]
      },
      []
    )

    setPartRequests(placeholders)
  }

  return (
    <Table>
      <Thead>
        <Tr>
          <Th>Part Number</Th>
          <Th>Description</Th>
          <Th>Quantity</Th>
          <Th>Add to Quote</Th>
        </Tr>
      </Thead>
      <Tbody>
        {partRequests.map((partRequest) => (
          <Tr key={`${partRequest.mpn}${partRequest.description}${partRequest.quantity}`}>
            <Td>{partRequest.mpn}</Td>
            <Td>{partRequest.description}</Td>
            <Td>{partRequest.quantity}</Td>
            <Td>
              <Checkbox
                disabled={!addToQuoteVisible}
                checked={partRequest.addToQuote}
                setChecked={(addToQuote) => alterPartRequest({ id: partRequest.id, addToQuote })}
              />
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  )
}

export default PartRequestsTable
